import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    AlertIcon,
    CheckCircleIcon,
    colors
} from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";

import { StatusIconProps } from "./types";

const StatusIcon = ({ isExpired, isRestricted }: StatusIconProps) => {
    const { green600, red700, textDisabled } = colors;

    const { t } = useTranslation();

    return (
        <TooltipGeneral
            placement={TOOLTIP_PLACEMENT.Top}
            title={
                isExpired
                    ? t("Dialog##token has expired")
                    : t("Dialog##token is valid")
            }
            disableHoverListener={isRestricted}
            disableTouchListener
        >
            <span>
                {isExpired ? (
                    <AlertIcon
                        css={css({
                            color: isRestricted ? textDisabled : red700
                        })}
                    />
                ) : (
                    <CheckCircleIcon
                        css={css({
                            color: isRestricted ? textDisabled : green600
                        })}
                    />
                )}
            </span>
        </TooltipGeneral>
    );
};

export default StatusIcon;
